import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Onboarding.css';
import { useAuth } from '../contexts/AuthContext';
import { database } from '../supabase';
import OnboardingDebug from '../components/OnboardingDebug';
import { REQUIRE_ONBOARDING } from '../config/features';

const Onboarding = () => {
    const navigate = useNavigate();
   

    const steps = [ 
        {
            id: 1,
            // main_header: 'Hi I\'m Study-Space 👋',
            // sub_heading: 'Help me learn how to make the experience personalized for you.',
        question: 'I am a...',
        options: [
            { id: 1, label: 'Student', value: 'student', icon: 'https://iili.io/K8OciSp.png' },
            { id: 2, label: 'Teacher', value: 'teacher', icon: 'https://iili.io/K8O07v2.png' },
            { id: 3, label: 'Professor', value: 'professor', icon: 'https://iili.io/K8OMnSf.png' },
            { id: 4, label: 'Parent', value: 'parent', icon: 'https://iili.io/K8OOpcP.png' },
            
        ]
        },
        {
            id: 2,
            main_header: 'Let\'s get to know you better',
            // sub_heading: 'What is your current level of education?',
            question: 'What is your current level of education?',
            options: [
                { id: 1, label: 'High School Student', value: 'high_school_student', icon: 'https://iili.io/K8OciSp.png' },
                { id: 2, label: 'College Student', value: 'college_student', icon: 'https://iili.io/K8O07v2.png' },
                { id: 3, label: 'Graduate Student', value: 'graduate_student', icon: 'https://iili.io/K8OMnSf.png' },
                { id: 4, label: 'Learning for fun', value: 'learning_for_fun', icon: 'https://iili.io/K8OOpcP.png' },
                { id: 5, label: 'Other', value: 'other' }
            ]
        },
        {
            id: 3,
            main_header: 'What are your interests?',
            // sub_heading: 'This helps us recommend the right content for you.',
            question: 'How did you hear about Study-Space?',
             options: [
                { id: 1, label: 'TikTok', value: 'tiktok', icon: 'https://iili.io/K8Okk42.png' },
                { id: 2, label: 'Twitter', value: 'twitter', icon: 'https://iili.io/K8O8Axa.png' },
                { id: 3, label: 'Instagram', value: 'instagram', icon: 'https://iili.io/K8OUIna.png' },
                { id: 4, label: 'Google', value: 'google', icon: 'https://iili.io/K8OgfiG.png' },
                { id: 5, label: 'Classmate', value: 'classmate', icon: 'https://iili.io/K8ObVIf.png' },
                { id: 6, label: 'Other', value: 'other' }
            ]
        },
        {
            id: 4,
            main_header: 'Almost done!',
            // sub_heading: 'Where could you use the most support studying right now?',
            question: 'Where could you use the most support studying right now?',
            options: [
                { id: 1, label: 'Help me with homework', value: 'beginner' },
                { id: 2, label: 'Help me study for a test', value: 'intermediate' },
                { id: 3, label: 'Help me understand a complex topic', value: 'advanced' },
                { id: 4, label: 'Help me prepare for a presentation', value: 'presentation' }
            ]
        }
        
    ]

    const [currentStep, setCurrentStep] = useState(0);
    const [selectedAnswers, setSelectedAnswers] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { user, authInitialized } = useAuth();

    useEffect(() => {
        if (REQUIRE_ONBOARDING) return;
        if (!authInitialized) return;
        if (user?.uid) navigate(`/main/${user.uid}`, { replace: true });
        else navigate('/', { replace: true });
    }, [user, authInitialized, navigate]);

    // Use ref to track answers in real-time
    const answersRef = useRef({});

    const handleOptionSelect = (optionValue) => {
        console.log('Selecting option:', optionValue, 'for step:', currentStep);
        
        // Update both state and ref
        const newAnswers = {...answersRef.current, [currentStep]: optionValue};
        answersRef.current = newAnswers;
        setSelectedAnswers(newAnswers);
        
        console.log('Updated selectedAnswers:', newAnswers);
        console.log('Updated answersRef:', answersRef.current);
        
        // Move to next question with the updated answers
        nextQuestion(newAnswers);
    };
    const nextQuestion = async (answersToUse = answersRef.current) => {
        // Check if we're on the last question
        if (currentStep === steps.length - 1) {
            try {
                // Show loader first
                setIsLoading(true);
                
                // Get the Supabase user ID from Firebase UID
                console.log('Getting Supabase user for Firebase UID:', user.uid);
                const supabaseUser = await database.getUserByFirebaseUid(user.uid);
                console.log('Supabase user found:', supabaseUser);
                
                if (!supabaseUser) {
                    console.error('User not found in Supabase');
                    throw new Error('User not found in Supabase');
                }

                // Prepare answers array in the correct order
                const answers = [
                    answersToUse[0], // Step 1: current role
                    answersToUse[1], // Step 2: discovery source
                    answersToUse[2], // Step 3: study interests
                    answersToUse[3]  // Step 4: expertise level
                ];
                
                console.log('Current selectedAnswers object:', answersToUse);
                console.log('Prepared answers array:', answers);
                
                // Check if we have all answers
                const hasAllAnswers = answers.every(answer => answer !== undefined && answer !== null);
                console.log('Has all answers:', hasAllAnswers);
                
                if (!hasAllAnswers) {
                    throw new Error('Missing some onboarding answers');
                }

                // Save onboarding answers to Supabase
                await database.saveOnboardingAnswers(supabaseUser.id, answers);
                console.log('Onboarding answers saved successfully');
                
                // Mark onboarding as completed
                console.log('Marking onboarding as completed for user ID:', supabaseUser.id);
                console.log('Supabase user object before marking:', supabaseUser);
                const markResult = await database.markOnboardingCompleted(supabaseUser.id);
                console.log('Mark onboarding result:', markResult);
                console.log('Onboarding marked as completed');
                
                // Verify the update worked by fetching the user again
                const verifyUser = await database.getUserByFirebaseUid(user.uid);
                console.log('Verification - User after marking complete:', verifyUser);
                console.log('Verification - onboarding_completed:', verifyUser?.onboarding_completed);
                
                console.log('Onboarding completed successfully!');
                
                // Redirect immediately after successful completion
                console.log('🚀 Redirecting to main page:', '/main/' + user.uid);
                navigate('/main/' + user.uid);
                
            } catch (error) {
                console.error('Error saving onboarding answers:', error);
                // Still redirect even if saving fails
                navigate('/main/' + user.uid);
            }
        } else {
            // Move to next question
            setCurrentStep(currentStep + 1);
            setSelectedAnswers({...selectedAnswers, [currentStep]: selectedAnswers[currentStep]});
        }
    }

    const prevQuestion = () => {
        setCurrentStep(currentStep - 1);
        setSelectedAnswers({...selectedAnswers, [currentStep]: selectedAnswers[currentStep]});
    }



  
    // Show loader when onboarding is complete
    if (isLoading) {
        return (
            <div className='onboarding-container-card'>
                <div className='onboarding-loader'>
                    <div className='onboarding-loader-spinner'></div>
                    <h2>Perfect! Now we're setting up your personalized experience...</h2>
                    <p>This will only take a moment</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            {/* <OnboardingDebug /> */}
            <div className='onboarding-container-card'>

                <img src="https://iili.io/KYpg7rg.png" alt="StudySpace" style={{marginBottom: 'unset'}} className='onboarding-container-card-logo' />
                <p className='onboarding-container-card-step'>Step {currentStep + 1} of {steps.length}</p>
                <h1 className='onboarding-container-card-header'>{steps[currentStep].main_header}</h1>
                <p className='onboarding-container-card-sub-heading'>{steps[currentStep].sub_heading}</p>
                <p className='onboarding-container-card-question'>{steps[currentStep].question}</p>
             
             <div className='onboarding-container-card-options-container'>

                <div className='onboarding-container-card-options'>
                    {steps[currentStep].options.map((option) => (
                        <div
                            className='onboarding-container-card-option'
                            key={`step-${currentStep}-option-${option.id}`}
                            onClick={() => handleOptionSelect(option.value)}
                        >
                            {option.icon ? (
                                <>
                                    <img
                                        alt="Option Icon"
                                        src={option.icon}
                                        className='onboarding-container-card-option-icon'
                                    />
                                    {option.label}
                                </>
                            ) : (
                                option.label
                            )}
                        </div>
                    ))}
                </div>
             </div>
             

                <div className='onboarding-container-card-buttons'>
                    {currentStep > 0 && (
                        <button className='onboarding-container-card-button' onClick={prevQuestion}>Previous</button>
                    )}
                    <div className='onboarding-container-card-button' onClick={nextQuestion}>Next</div>

                </div>

            </div>
        </div>
    )
}

export default Onboarding;